import {getSearchList} from '../api/getSearchList';
import {setGetSearchListAction} from '../action';
import { setLoadingAction } from '../../../components/templatePage/store/action';

const setGetSearchList = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getSearchList(params);

            if (data.status === 'success') {
                const games = [...getState().providerMobile.search.data];
                games.push(data.data);

                dispatch(setGetSearchListAction({
                    data: games.flat(1),
                    countPage: data.countPage
                }));     
                dispatch(setLoadingAction(false))      
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetSearchList
}